import React from "react";

const BuildingTypeDropdown = ({ buildingTypes, selectedBuildingType, onChange }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium mb-1">Building Type:</label>
      <select className="w-full p-2 border rounded" value={selectedBuildingType} onChange={onChange}>
        <option value="">Select Building Type</option>
        {buildingTypes.map((type) => (
          <option key={type} value={type}>{type}</option>
        ))}
      </select>
    </div>
  );
};

export default BuildingTypeDropdown;
